// components/KbBees.tsx
// Playful KB mascot cheer built by cycling /assets/kb/frame-1..N.png. Ported
// verbatim (behavior) from swa-rprs/client/src/components/KbBees.jsx. Shown in
// the BugReporter success state. Preload on modal-open so it plays instantly.
import React, { useEffect, useState } from 'react';

const BASE = '/assets/kb/frame-';
const DEFAULT_COUNT = 8;

// Warm the frame cache when the report modal OPENS (not on mount) so the cheer
// plays with no first-frame delay on success. Idempotent + cheap.
export function preloadKbBees(count = DEFAULT_COUNT): void {
  if (typeof Image === 'undefined') return;
  for (let n = 1; n <= count; n++) { const im = new Image(); im.src = `${BASE}${n}.png`; }
}

export default function KbBees({ size = 132, fps = 8, count = DEFAULT_COUNT }: { size?: number; fps?: number; count?: number }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => { preloadKbBees(count); }, [count]);
  useEffect(() => {
    const id = setInterval(() => setIdx(p => (p + 1) % count), Math.round(1000 / fps));
    return () => clearInterval(id);
  }, [fps, count]);

  return (
    <img
      src={`${BASE}${idx + 1}.png`}
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', margin: '0 auto 6px', objectFit: 'contain' }}
    />
  );
}
